import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocAssignCustomRolesRoute: InvariantJiraRoute = {
	name: 'eoc-assign-custom-roles',
	path: '/jira/settings/products/ops/role-assignment',
	exact: true,
};
